import { createStructuredSelector } from "reselect";
import {
    IDX_RPT_EQUIPMENT_REPORT,
    IDX_RPT_EQUIPMENT_REPORT_SUCCESS,
    IDX_RPT_EQUIPMENT_REPORT_ERROR,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_EQP,
    IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR,
    IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR,
    IDX_RPT_EQUIPMENT_SERVICE_LIST,
    IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS,
    IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR
} from "../../actions";

export const NAME = 'idxRptEquipment';


export const IdxRptEquipmentReport = (data) => ({
    type: IDX_RPT_EQUIPMENT_REPORT,
    payload: data
});

export const IdxRptEquipmentReportSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_REPORT_SUCCESS,
    payload: data
});

export const IdxRptEquipmentReportError = (error) => ({
    type: IDX_RPT_EQUIPMENT_REPORT_ERROR,
    payload: error
});

export const IdxRptEquipmentHospitalList = (data) => ({
    type: IDX_RPT_EQUIPMENT_HOSPITAL_LIST,
    payload: data
});

export const IdxRptEquipmentHospitalListSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    payload: data
});

export const IdxRptEquipmentHospitalListError = (error) => ({
    type: IDX_RPT_EQUIPMENT_HOSPITAL_LIST_ERROR,
    payload: error
});

export const IdxRptEquipmentDetailEQP = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_EQP,
    payload: data
});

export const IdxRptEquipmentDetailEQPSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_EQP_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailEQPError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_EQP_ERROR,
    payload: error
});

export const IdxRptEquipmentDetEQPSearchChange = (data) => ({
    type: IDX_RPT_EQUIPMENT_DET_EQP_SEARCH_CHANGE,
    payload: data
});

export const IdxRptEquipmentDetailNoLocation = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION,
    payload: data
});

export const IdxRptEquipmentDetailNoLocationSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailNoLocationError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION_ERROR,
    payload: error
});

export const IdxRptEquipmentDetailOperationStatus = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS,
    payload: data
});

export const IdxRptEquipmentDetailOperationStatusSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailOperationStatusError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS_ERROR,
    payload: error
});


export const IdxRptEquipmentDetailRequiredQuantity = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY,
    payload: data
});

export const IdxRptEquipmentDetailRequiredQuantitySuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailRequiredQuantityError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY_ERROR,
    payload: error
});


export const IdxRptEquipmentDetailOthers = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OTHERS,
    payload: data
});

export const IdxRptEquipmentDetailOthersSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OTHERS_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailOthersError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_OTHERS_ERROR,
    payload: error
});

export const IdxRptEquipmentDetailNoJustification = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION,
    payload: data
});

export const IdxRptEquipmentDetailNoJustificationSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_SUCCESS,
    payload: data
});

export const IdxRptEquipmentDetailNoJustificationError = (error) => ({
    type: IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION_ERROR,
    payload: error
});

export const IdxRptEquipmentEvaluationForm = (data) => ({
    type: IDX_RPT_EQUIPMENT_EVALUATION_FORM,
    payload: data
});

export const IdxRptEquipmentEvaluationFormSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_EVALUATION_FORM_SUCCESS,
    payload: data
});

export const IdxRptEquipmentEvaluationFormError = (error) => ({
    type: IDX_RPT_EQUIPMENT_EVALUATION_FORM_ERROR,
    payload: error
});

export const IdxRptReqEqpHospitalService = (data) => ({
    type: IDX_RPT_REQ_EQP_HOSPITAL_SERVICE,
    payload: data
});

export const IdxRptReqEqpHospitalServiceSuccess = (data) => ({
    type: IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_SUCCESS,
    payload: data
});

export const IdxRptReqEqpHospitalServiceError = (error) => ({
    type: IDX_RPT_REQ_EQP_HOSPITAL_SERVICE_ERROR,
    payload: error
});

export const IdxRptEquipmentServiceList = (data) => ({
    type: IDX_RPT_EQUIPMENT_SERVICE_LIST,
    payload: data
});

export const IdxRptEquipmentServiceListSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_SERVICE_LIST_SUCCESS,
    payload: data
});

export const IdxRptEquipmentServiceListError = (error) => ({
    type: IDX_RPT_EQUIPMENT_SERVICE_LIST_ERROR,
    payload: error
});

export const IdxRptEquipmentTechnologyType = (data) => ({
    type: IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE,
    payload: data
});

export const IdxRptEquipmentTechnologyTypeSuccess = (data) => ({
    type: IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_SUCCESS,
    payload: data
});

export const IdxRptEquipmentTechnologyTypeError = (error) => ({
    type: IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE_ERROR,
    payload: error
});

export const IdxRptReqEquipmentByTechnologyType = (data) => ({
    type: IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE,
    payload: data
});

export const IdxRptReqEquipmentByTechnologyTypeSuccess = (data) => ({
    type: IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_SUCCESS,
    payload: data
});

export const IdxRptReqEquipmentByTechnologyTypeError = (error) => ({
    type: IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE_ERROR,
    payload: error
});


const idxRptEquipment = (state) => state[NAME];

export const IdxRptEquipmentSelector = createStructuredSelector({
    idxRptEquipment
})